import { useDepositStyles } from "./deposit/deposit.styles";
import DepositMessage from "./deposit/DepositMessage";
import DepositLoading from "./deposit/DepositLoading";
import { Typography } from "@mui/material";

interface LoadingOrErrorManagerProps {
  error: {
    onClose: () => void;
    message: any | null;
    isError: boolean;
  };
  success: {
    onClose: () => void;
    message: any | null;
    isSuccess: boolean;
  };
  loading: boolean;
  children: JSX.Element;
}

const LoadingOrErrorManager = (props: LoadingOrErrorManagerProps): JSX.Element => {
  const { error, loading, success, children } = props;

  const classes = useDepositStyles();

  return (
    <>
      {error.isError ? (
        <DepositMessage message={error.message} onClose={error.onClose} />
      ) : success.isSuccess ? (
        <DepositMessage message={success.message} onClose={success.onClose} />
      ) : loading ? (
        <DepositLoading />
      ) : (
        <div className={classes.container}>{children}</div>
      )}
    </>
  );
};

export default LoadingOrErrorManager;
